import React, { useEffect } from 'react';
import { EventProduct } from '@/api';
import useTrackEvent from '../useTrackEvent';
import EventLoading from '../EventLoading';
import PopupCompletedSales from './PopupCompleted.sales';
import PopupCompletedTotal from './PopupCompleted.total';
import { PopupEventVendorDetailsCompleted } from '../types';
import { getRestaurantInfo } from '../helpers';
import { usePopupCompletedEvent } from './usePopupCompletedEvent';
import { getFullLocationAddress } from '@/pages/Dashboard.page/helpers';
import { EventHeading } from '../EventHeadings/EventHeading';
import { EventDetails } from '../shared/Event.details';
import { Stack } from '@mantine/core';
import dayjs from 'dayjs';

export const PopupCompleted: React.FC<{ id: string; onCloseWithoutEvent: () => void }> = ({
  id,
  onCloseWithoutEvent,
}) => {
  const { event, loading } = usePopupCompletedEvent(id);

  useTrackEvent(event);

  useEffect(() => {
    if (!loading && !event) {
      onCloseWithoutEvent();
    }
  }, [loading, event, onCloseWithoutEvent]);

  if (loading) {
    return <EventLoading />;
  }

  if (!event) {
    return <></>;
  }

  const eventTitle = `${event.productType.toLowerCase()} Event Details`;
  const baseStartTime =
    event.productType === EventProduct.CAFE
      ? event.eventLocation?.serviceStartTime ?? event.popupEvent.startTime
      : event.popupEvent.startTime;
  const eventDetails = {
    setupTime: dayjs(baseStartTime)
      .subtract(event.eventLocation?.setupTime ?? 0, 'minutes')
      .toISOString(),
    endTime: event.popupEvent.endTime,
    startTime: event.popupEvent.startTime,
    restaurant: getRestaurantInfo(event.vendor?.internalName, event.vendor?.address),
    placeName: event.popupEvent.account.name,
    locationAddress: getFullLocationAddress(event.eventLocation?.location),
  };

  const effectiveStartTime = dayjs(baseStartTime)
    .subtract(event.eventLocation?.setupTime ?? 0, 'minute')
    .toISOString();


  return (
    <EventHeading eventStartTime={effectiveStartTime} title={eventTitle}>
      <Stack>
        <EventDetails eventDetails={eventDetails} />
        <PopupCompletedSales event={event} />
        <PopupCompletedTotal event={event} />
      </Stack>
    </EventHeading>
  );
};

